import { SectionButtonLink } from './Section';
import { useParams } from 'react-router-dom';
import { SectionConfig } from './ClosingPageSectionConfig';
import { SanitizedHtml } from './SanitizedHtml';
import { Section } from './Section';
import { Typography } from '@mui/material';

export function CustomSection({ sectionConfig, collapsible }: {
  sectionConfig: SectionConfig;
  collapsible?: boolean;
}) {
  const { section } = useParams()
  const isCustomSection = section?.includes('CustomSection')

  return ( isCustomSection ?
    <Typography paragraph>
      <SanitizedHtml html={sectionConfig.contentTokenValue ?? ''} />
    </Typography>
    :
    sectionConfig.displayType === 'closingPage' ? (
      <Section
        title={sectionConfig.name}
        icon={sectionConfig.icon}
        collapsible={collapsible}
      >
        <Typography paragraph>
          <SanitizedHtml html={sectionConfig.contentTokenValue ?? ''} />
        </Typography>
      </Section>
    ) : (
      <SectionButtonLink
        title={sectionConfig.name}
        icon={sectionConfig.icon}
        to={sectionConfig.routeTo ?? ''}
      />
    )
  )
}